import { UsersService } from "./implementations/users.service";

export default defineNuxtPlugin((nuxtApp) => {
  const users = new UsersService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      users: users,
    },
  };
});
